import AppleSignin from 'react-apple-signin-auth';
import {
  useToast,
  IconButton
} from '@chakra-ui/react';
import { FaApple } from 'react-icons/fa';

const APPLE_CLIENT_ID = process.env.REACT_APP_APPLE_CLIENT_ID || "your-apple-client-id";
const APPLE_REDIRECT_URI = process.env.REACT_APP_APPLE_REDIRECT_URI || "https://your-domain.com/auth/apple/callback";

const AppleAuthButton = ({
  onSuccess,
  onError,
  isLoading = false
}) => {
  const toast = useToast();

  const handleSuccess = (response) => {
    if (onSuccess) {
      onSuccess(response);
    }
  };

  const handleError = (error) => {
    console.error('Apple Sign-In Error:', error);
    toast({
      title: 'Apple Sign-In Failed',
      description: 'Please try again or use manual registration',
      status: 'error',
      duration: 3000,
      isClosable: true,
    });
    if (onError) {
      onError(error);
    }
  };

  return (
    <>
      <AppleSignin
        authOptions={{
          clientId: APPLE_CLIENT_ID,
          scope: 'email name',
          redirectURI: APPLE_REDIRECT_URI,
          state: 'signin',
          nonce: `nonce_${Date.now()}`,
          usePopup: true
        }}
        uiType="dark"
        className="apple-auth-btn"
        noDefaultStyle={true}
        onSuccess={handleSuccess}
        onError={handleError}
        skipScript={false}
        render={(renderProps) => (
          <IconButton
            icon={<FaApple />}
            onClick={renderProps.onClick}
            disabled={isLoading || renderProps.disabled}
            size="md"
            width="48px"
            height="48px"
            bg="black"
            color="white"
            borderRadius="8px"
            border="1px solid"
            borderColor="#333"
            isLoading={isLoading}
            aria-label="Sign in with Apple"
            _hover={{
              bg: "#333",
              borderColor: "#555"
            }}
          />
        )}
      />
    </>
  );
};

export default AppleAuthButton;